import { RequestAdjustItemErrorEnum } from '@shared/enum/manage-stock.emun';
import { ArticlesContent } from '@shared/models/articles.model';
import { BaseReport } from '@shared/models/base-report.model';

export interface Money {
  amount: number;
  currency?: string;
}

export class StockAdjustSearchCriteria {
  searchCriteria?: string;
  status?: string;
  createdDateFrom?: string;
  createdDateTo?: string;
  locationType?: string[];
  adjustType?: string[];
  page: number;
  size: number;
  sortBy?: string;
  sortOrder?: string;
}

export class StockAdjustPagination {
  page: number;
  size: number;
  totalElements: number;
  first: boolean;
  numberOfElements: number;
  totalPages: number;
  hasContent: boolean;
  last: boolean;
  empty: boolean;
  content: StockAdjustContent[];
}

export class StockAdjustContent {
  id: string;
  docNo: string;
  requestNo: string;
  locationCode: string;
  locationName: string;
  locationCodeName: string;
  requester: string;
  status: string;
  locationType: string;
  requestedDate: string;
  createdByName: string;
  createdDate: string;
  adjustType?: string;
  refNo?: string;
  allowToForceComplete?: boolean;
}

export class AdjustStockRequest {
  adjustType: string;
  refNo: string;
  locationType: string;
  location: string;
  items: AdjustItem[];
}

export class AdjustStockResponse {
  id: string;
  version: number;
  docNo: string;
  requestNo: string;
  items?: AdjustItem[];
  location: string;
  locationType?: string;
  adjustType: string;
  status: string;
  refNo: string;
  createdDate: Date | string;
  createdBy: string;
  createdByName: string;
  lastModifiedBy: string;
  lastModifiedByName: string;
  lastModifiedDate: Date | string;
  picturePaths?: string[];
  allowToForceComplete?: boolean;
}

export class AdjustStockItemCriteria {
  page: number;
  size: number;
  sortBy?: string;
  sortOrder?: string;
}

export class AdjustStockItemPagination {
  page: number;
  size: number;
  totalElements: number;
  first: boolean;
  numberOfElements: number;
  totalPages: number;
  hasContent: boolean;
  last: boolean;
  empty: boolean;
  content: AdjustStockItemContent[];
}

export class AdjustStockItemContent {
  id?: string;
  articleNo: string;
  productName: string;
  adjustStock: number;
  unit: string;
  unitFactor: string;
  reason: string;
  reasonDetails?: ReasonDetail[];
  barcode: string;
}

export interface ReasonDetail {
  reason: string;
  picturePaths: string[];
}

export class AdjustStockResponseError {
  code: string;
  message: string;
  items: ItemsErrorList[];
  detail?: AdjustStockErrorDetail;
}

export class AdjustStockErrorDetail {
  referenceNo: string;
  errorMessage: RequestAdjustItemErrorEnum;
  items: ItemsErrorList[];
}

export class ItemsErrorList {
  articleNo: string;
  errorMessage: RequestAdjustItemErrorEnum;
}

export class AdjustItem {
  id?: string;
  articleNo: string;
  productName: string;
  adjustStock: number;
  unit: string;
  unitFactor: string;
  reason: string;
  barcode?: string;
  productStatus?: string;
  productType?: string;
  errorMessage?: RequestAdjustItemErrorEnum;
  classCode?: string;
  vat?: boolean;
  retailPricePerUnit?: Money;
  retailPriceExcVatPerUnit?: Money;
  retailPriceVatPerUnit?: Money;

  public static mappingArticleResponseToProductItem(response: ArticlesContent): AdjustItem {
    return {
      ...response,
      adjustStock: null,
      reason: null,
      errorMessage: null,
      amount: { amount: 0, currency: response.unitPrice?.currency },
      amountExcVat: { amount: 0, currency: response.unitPriceExcVat?.currency },
      vatAmount: { amount: 0, currency: response.unitPriceVat?.currency }
    } as AdjustItem;
  }
}

export class ExportAdjustCriteria extends BaseReport {
  locationTypes?: string[];
  adjustTypes?: string[];
  createdDateFrom: string;
  createdDateTo: string;
  fileType?: string;

  constructor(init?: Partial<ExportAdjustCriteria>) {
    super();
    Object.assign(this, init);
  }
}

export interface ImportAdjustItem {
  articleNo: string;
  barcode: string;
  productName: string;
  adjustStock: number;
  reason: string;
  unit: string;
  unitFactor: number;
}

export class RequestImportAdjustStock {
  items: ImportAdjustItem[];
  location: string;
  locationType: string;
  adjustType: string;
  refNo: string;
}

export class ResponseImportAdjustStock {
  items: ImportAdjustItem[];
  location: string;
  locationType: string;
  adjustType: string;
  refNo: string;
}

export class Image {
  no?: number;
  articleNo?: string;
  reason?: string;
  image: any;
  thumbImage?: string;
  title: string;
}

export class AdjustStockForceComplete {
  id: string;
  reason: string;
}

export interface AdjustStockRequestNo {
  docNo: string;
}
